var render = function render(){var _vm=this,_c=_vm._self._c;return _c('message-bubble',{attrs:{"isMine":_vm.isMine}},[_c('a',{staticClass:"geo-element",attrs:{"href":_vm.href,"target":"_blank","title":"点击查看详情"}},[_c('span',{staticClass:"el-icon-location-outline"},[_vm._v(_vm._s(_vm.payload.description))]),_c('img',{attrs:{"src":_vm.url}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }